import { Link } from "react-router-dom";
import Seo from "../components/site/Seo";

export default function NotFound() {
  return (
    <div className="container-x py-24">
      <Seo title="Page not found" path="/404" description="This page could not be found." />
      <h1 className="font-display text-4xl font-bold text-teal">We couldn't find that page</h1>
      <p className="mt-4 text-lg">The page may have moved. Try the home page or contact us.</p>
      <div className="mt-8 flex gap-3"><Link to="/" className="btn-primary">Go to home page</Link><Link to="/contact" className="btn-outline">Contact us</Link></div>
    </div>
  );
}
